import React from 'react';
import { WebsiteDesignProps } from './types';
import { Pen, Eraser, Lightbulb } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ChalkboardArt: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Blackboard School";

    return (
        <div className="bg-[#2b4c3b] text-white min-h-screen font-sans relative overflow-hidden">
            {/* Texture */}
            <div className="fixed inset-0 pointer-events-none opacity-40" style={{
                backgroundImage: 'url("https://www.transparenttextures.com/patterns/black-felt.png")',
                filter: 'contrast(150%) brightness(120%)'
            }}></div>
            
            {/* Chalk Dust */}
            <div className="fixed inset-0 pointer-events-none bg-gradient-radial from-transparent to-[#1a2e24] opacity-80"></div>

            <nav className="relative z-20 p-8 flex justify-between items-center">
                <div className="text-3xl font-handwriting transform -rotate-2 border-b-2 border-white/50 pb-1" style={{fontFamily: 'cursive'}}>
                    {schoolName}
                </div>
                <div className="flex gap-4 font-handwriting text-xl">
                    <a href="#" className="hover:text-yellow-200 hover:underline">Assignments</a>
                    <a href="#" className="hover:text-yellow-200 hover:underline">Grades</a>
                </div>
            </nav>

            <main className="container mx-auto px-8 py-20 relative z-10 text-center">
                 <div className="border-4 border-dashed border-white/20 p-12 rounded-lg inline-block bg-white/5 backdrop-blur-sm shadow-xl">
                     <h1 className="text-6xl md:text-8xl font-handwriting mb-8 text-white/90" style={{fontFamily: 'cursive', textShadow: '2px 2px 4px rgba(0,0,0,0.5)'}}>
                         Knowledge is <br/> Power
                     </h1>
                     <p className="text-2xl font-handwriting text-yellow-200 mb-10 max-w-xl mx-auto transform rotate-1">
                         ( Class is in session! Don't be late! )
                     </p>
                     
                     <div className="flex justify-center gap-8">
                         <div className="flex flex-col items-center gap-2 group cursor-pointer">
                             <div className="w-16 h-16 rounded-full border-2 border-white/50 flex items-center justify-center group-hover:bg-white/10 transition-colors">
                                 <Lightbulb size={32} />
                             </div>
                             <span className="font-handwriting text-lg">Ideas</span>
                         </div>
                         <div className="flex flex-col items-center gap-2 group cursor-pointer">
                             <div className="w-16 h-16 rounded-full border-2 border-white/50 flex items-center justify-center group-hover:bg-white/10 transition-colors">
                                 <Pen size={32} />
                             </div>
                             <span className="font-handwriting text-lg">Create</span>
                         </div>
                         <div className="flex flex-col items-center gap-2 group cursor-pointer">
                             <div className="w-16 h-16 rounded-full border-2 border-white/50 flex items-center justify-center group-hover:bg-white/10 transition-colors">
                                 <Eraser size={32} />
                             </div>
                             <span className="font-handwriting text-lg">Iterate</span>
                         </div>
                     </div>
                 </div>

                 <div className="mt-16 text-white/40 font-handwriting text-4xl">
                     E = mc<sup>2</sup>
                 </div>
            </main>
        </div>
    );
};

export default ChalkboardArt;
